import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  CODE_GENERATION_PATH,
  CODE_GENERATION_DETAIL_PATH,
  CODE_GENERATION_DETAIL_ID_PATH,
} from "utils/constants/paths";

const CodeGeneration = Loadable(React.lazy(() => import("./View")));
const CodeGenerationDetail = Loadable(
  React.lazy(() => import("./View/Detail"))
);

export const CodeGenerationRoute: IRouteItem = {
  path: CODE_GENERATION_PATH,
  iconName: "DocumentCode",
  element: React.createElement(CodeGeneration),
  name: "Code Generation",
  accessKeys: ["CodeGenerator"],
  children: [
    {
      name: "Detail",
      path: CODE_GENERATION_DETAIL_PATH,
      element: "",
      showInDrawer: false,
    },
    {
      path: CODE_GENERATION_DETAIL_ID_PATH,
      element: React.createElement(CodeGenerationDetail),
      showInDrawer: false,
    },
  ],
};
